import { Validator } from 'vee-validate';
import i18n from 'src/i18n';

export const extendValidators = () => {
  Validator.extend('positive_decimal', {
    getMessage: (field) =>
      `${field}: ${i18n.t('inventory.positive_number_with_decimals')}`,
    validate: (value) => {
      return /^\d+(\.\d+)?$/.test(value);
    },
  });
};